module.exports = __webpack_public_path__ + "static/lightning-datetime-picker-a67326ba4f60e46b71fd0cd91805a405.png";